// KP-4363: search the products of one order on the order page.

const lower = value => (value === undefined || value === null ? '' : String(value).toLowerCase())

const getSearchableTexts = product => {
  const itemTexts = (product.items || []).flatMap(item => [item.sku, item.skuId, item.color])
  return [product.name, product.styleCode, product.color, ...itemTexts].map(lower)
}

/**
 * Products whose name, style code, color or item sku contains the query
 * (case-insensitive). A blank query returns the list unchanged. The same
 * product objects are returned, never copies.
 */
export function filterOrderProductsBySearch(products, query) {
  const needle = lower(query).trim()
  if (!needle) return products
  return (products || []).filter(product => getSearchableTexts(product).some(text => text.includes(needle)))
}
